import React, { useEffect, useState } from 'react';
import { messages } from '../../../../messages';
import { validateEmail, phoneNumberMask, ShirtSize } from '../../../helper';
import NumberFormat from 'react-number-format';
import CustomSelect from '../../../CustomSelect/CustomSelect';
import { LoaderMini } from '../../../Loader';

export default function ModifyAccountPopup(props) {
    const data = props.formData;
    const [checkbox, setCheckbox] = useState(!!data.account_locked);
    
    useEffect(() => {
        if(!checkbox){
            setCheckbox(!!data.account_locked);
        }
        // eslint-disable-next-line
    }, [data])
    
    useEffect(() => {
        if (props.handleFormChange) {
            props.handleFormChange({
                target: {
                    name: 'account_locked',
                    value: checkbox,
                }
            });
        }
        //eslint-disable-next-line
    }, [checkbox]);
    return <>
        <div className="modifyAdmin-popup">
            <div className="input-field">
                <label>First Name<sup>*</sup></label>
                <input type="text" name="first_name" value={data.first_name} onChange={props.handleFormChange} />
                {props.formSubmitted && !(data.first_name || '').trim() && <span className="error">{messages.emptyName}</span>}
            </div>
            <div className="input-field">
                <label>Last Name<sup>*</sup></label>
                <input type="text" name="last_name" value={data.last_name} onChange={props.handleFormChange} />
                {props.formSubmitted && !(data.last_name || '').trim() && <span className="error">{messages.emptyLastName}</span>}
            </div>
            <div className="input-field input-field-email">
                <label>Email<sup>*</sup></label>
                <div className="email-spinner-wrapper">
                    <input type="text" name="email" value={data.email} onChange={(e) => props.handleFormChange({ target: { name: 'email', value: e.target.value } }, true)} />
                    {props?.checkingEmail && <div className="spinner"><LoaderMini /></div>}
                </div>
                {props.formSubmitted && !(data.email || '').trim() && <span className="error">{messages.emptyEmail}</span>}
                {props.formSubmitted && (data.email || '').trim() && !validateEmail((data.email || '').trim()) && <span className="error">{messages.invalidEmail}</span>}
                {props.emailExist && <span className="error">{messages.email_taken}</span>}
            </div>
            <div className="input-field">
                <label>Primary Phone</label>
                <NumberFormat format={phoneNumberMask} mask="_" name="cell_phone" value={data.cell_phone} onChange={props.handleFormChange} />
                {props.formSubmitted && data.cell_phone && data.cell_phone.replace(/\D/g, '').length < 10  && <span className="error">{messages.phoneLength}</span>}
            </div>
            <div className="input-field">
                <label>Secondary Phone</label>
                <NumberFormat format={phoneNumberMask} mask="_" name="secondary_phone" value={data.secondary_phone} onChange={props.handleFormChange} />
                {props.formSubmitted && data.secondary_phone && data.secondary_phone.replace(/\D/g, '').length < 10  && <span className="error">{messages.phoneLength}</span>}
            </div>
            {props.type === 'user' && <CustomSelect
                required={true}
                data={Object.keys(ShirtSize).map(key => ({ id: key, title: ShirtSize[key] }))}
                label="Shirt Size"
                placeholder={data.shirt_size ? ShirtSize[data.shirt_size] : 'Select Shirt Size'}
                selector="title"
                onSelect={(event) => event && props.handleFormChange({
                    target: {
                        name: 'shirt_size',
                        value: event.id,
                    }
                })}
            />}
            <div className="checkbox-container">
                <label className="checkbox">
                    Lock Account
                    <input type="checkbox"
                        value={checkbox}
                        checked={checkbox}
                        name="account_locked"
                        onChange={() => setCheckbox(o => !o)}
                    />
                    <span className="checkmark"></span>
                </label>
            </div>
        </div>
    </>
}